import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import 'alertifyjs/build/css/alertify.css';
import 'alertifyjs/build/css/themes/default.css';
import 'daterangepicker/daterangepicker.css';
import 'manage/stylesheets/application.scss';

// bootstrap と daterangepicker のプラグイン、rails-ujs の ajaxPrefilter は、読み込んだ時点の jQuery に登録されるので jQuery を先に読み込む
import 'jquery';
import 'bootstrap/dist/js/bootstrap';
import 'daterangepicker';

import 'shared/adminProxyLoginPlatformIdCopy';
import 'shared/adminProxyLoginSwitcher';

import { Application } from '@hotwired/stimulus';
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers';
import Rails from '@rails/ujs';

Rails.start();

window.Stimulus = Application.start();
const context = require.context('../manage/controllers', true, /\.js$/);
Stimulus.load(definitionsFromContext(context));
